import { render, staticRenderFns } from "./DownloadPackingSlipButton.vue?vue&type=template&id=066fb808&"
import script from "./DownloadPackingSlipButton.vue?vue&type=script&lang=js&"
export * from "./DownloadPackingSlipButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports